<ul>
    @for (mainChapter of mainChapters; track mainChapter) {
        <li>
            <sidebar-chapter-pages [chapter]="mainChapter"></sidebar-chapter-pages>
        </li>
    }
</ul>

